import i18n from "../utils/locale/i18n";
import { Branches, CertificationType, Pool } from "../models/Organisation";
import Contract from "../models/Contract";
import Customer from "../models/Customer";
import { CompetenceItem } from "../models/Competence";

export const buildPoolKeyValues = (pools: Pool[], allLabel: string) => {
	return [
		{
			key: "",
			value: allLabel,
		},
		...pools.map((pool) => ({
			key: pool.key,
			value: pool.name,
		})),
	];
};

export const buildBranchesKeyValues = (branches: CompetenceItem[], allLabel: string) => {
	const tempBranch = branches.map((branch) => {
		return {
			key: branch?.key || "",
			value: branch?.name?.sv || "",
			items: branch?.items?.map((service) => {
				return {
					key: service?.key || "",
					value: service?.name?.sv || "",
				};
			}),
		};
	});

	return [
		{
			key: "",
			value: allLabel,
			items: [],
		},
		...tempBranch,
	];
};

export const buildContractKeyValues = (contracts: Contract[], allLabel: string) => {
	return [
		{
			key: "",
			value: allLabel,
		},
		...contracts.map((contract) => ({
			key: contract.id,
			value: contract.name + (contract.isDeleted ? " (arkiverat)" : ""),
		})),
	];
};

export const buildCustomerKeyValues = (customers: Customer[], allLabel: string) => {
	return [
		{
			key: "",
			value: allLabel,
		},
		...customers.map((customer) => ({
			key: customer.id,
			value: customer.name,
		})),
	];
};

export const statusTypes = () => {
	return [
		{ key: "", value: `${i18n.t("translation:ALL")}` },
		{ key: "true", value: `${i18n.t("translation:reports.filters.statusTypes.options.active")}` },
		{
			key: "false",
			value: `${i18n.t("translation:reports.filters.statusTypes.options.inActive")}`,
		},
	];
};

export const buildCertificationKeyValues = (
	certificationTypes: CertificationType[],
	allLabel: string
) => {
	return [
		{
			key: "",
			value: allLabel,
		},
		...certificationTypes.map((certificationType) => ({
			key: certificationType.key,
			value: certificationType.name.sv,
		})),
	];
};

/**
 * States a consultant/candidate can be in for a given certification type.
 * Mirrors CertificationStatus in oo-report-service.
 */
export const certificationStatusTypes = () => {
	return [
		{ key: "", value: `${i18n.t("translation:ALL")}` },
		{
			key: "valid",
			value: `${i18n.t("translation:reports.filters.certificationStatus.options.valid")}`,
		},
		{
			key: "expired",
			value: `${i18n.t("translation:reports.filters.certificationStatus.options.expired")}`,
		},
		{
			key: "missing",
			value: `${i18n.t("translation:reports.filters.certificationStatus.options.missing")}`,
		},
	];
};

export const jobStatusTypes = () => {
	return [
		{ key: "OPEN", value: `${i18n.t("translation:reports.filters.jobStatus.options.open")}` },
		{ key: "BOOKED", value: `${i18n.t("translation:reports.filters.jobStatus.options.booked")}` },
		// Note: For now there is no point in showing partially booked jobs as the reports are built
		// so BOOKED will include all booked shifts, even though job is partially booked.
		// {
		// 	key: "PARTIALLY_BOOKED",
		// 	value: `${i18n.t("translation:reports.filters.jobStatus.options.partiallyBooked")}`,
		// },
		{
			key: "DECLINED",
			value: `${i18n.t("translation:reports.filters.jobStatus.options.declined")}`,
		},
		{ key: "DELETED", value: `${i18n.t("translation:reports.filters.jobStatus.options.deleted")}` },
		{
			key: "CANCELLED",
			value: `${i18n.t("translation:reports.filters.jobStatus.options.cancelled")}`,
		},
	];
};

export const feedBackTypeTab = [
	{
		id: "consultant",
		label: "CONSULTANT",
	},
	{
		id: "customer",
		label: "CUSTOMER",
	},
];
